import { Alert } from "@msuite/ui/alert";
import { useTranslation } from "@msuite/ui/localization";
import type { PersonioSyncIssue } from "@msuite/utils/types";
import { countOutcomes, type PersonioSyncRun } from "./utils";

/** Props Interface */
interface PersonioSyncSummaryProps {
	createBlocker: Extract<PersonioSyncIssue, "no_sync_role" | "not_permitted"> | null;
	run: PersonioSyncRun | null;
}

export function PersonioSyncSummary({ createBlocker, run }: PersonioSyncSummaryProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Computed */
	const counts = run ? countOutcomes(run.results) : null;

	/** Guard */
	if (!createBlocker && !run) return null;

	/** Render */
	return (
		<div className="v-stack">
			{createBlocker && (
				<Alert
					variant="warning"
					spacing="compact"
					title={t(`integrations.personio_sync.${createBlocker}_title`)}
					description={t(`integrations.personio_sync.${createBlocker}_description`)}
				/>
			)}
			{counts && (
				<Alert
					variant={counts.failed ? "warning" : "success"}
					spacing="compact"
					title={t("integrations.personio_sync.summary_title")}
					description={t("integrations.personio_sync.summary", {
						created: counts.created.toString(),
						adopted: counts.adopted.toString(),
						linked: counts.linked.toString(),
						failed: counts.failed.toString(),
					})}
				/>
			)}
			{run && !run.areTeamsSynced && (
				<Alert
					variant="warning"
					spacing="compact"
					title={t("integrations.personio_sync.teams_not_synced_title")}
					description={t("integrations.personio_sync.teams_not_synced")}
				/>
			)}
		</div>
	);
}
